import { Button } from '@hai/ui-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAdaptiveFetch } from 'src/js/hook/use-adaptive-fetch';
import { useStores } from 'src/js/hook/use-stores';
import { StatisticTable } from 'src/js/pages/statistic/statistic-table';

import { MetadataViewModel } from './metadata-models';
import { mapMetadataToStatistics } from './metadata-statistics-content';
import { fetchMetadataStatistics, resetMetadataStatistics } from './metadata-store';

interface Props {
  model: MetadataViewModel;
}

export const MetadataStatistics: React.FunctionComponent<Props> = ({ model }) => {
  const { t } = useTranslation();
  const { sessionStore } = useStores();

  const [data, setData] = useState(model);
  useAdaptiveFetch(() => fetchMetadataStatistics(model, t, setData), 5000);

  const handleResetStatistics = () => {
    resetMetadataStatistics(model, t, setData);
  };

  return (
    <>
      <div className="mk-stats-container">
        <StatisticTable sections={mapMetadataToStatistics(data, t)} />
      </div>
      {!sessionStore.isUser() && (
        <div className="d-flex hai-mt-4">
          <Button className="ml-auto" variant="secondary" onClick={handleResetStatistics}>
            {t('statistics.button.resetStats')}
          </Button>
        </div>
      )}
    </>
  );
};
